import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from 'app/queries/jobs/jobsKeys';
import type { TCall } from 'app/queries/types/TCall';
import { buildOrganizationJobsRequest } from './buildOrganizationJobsRequest';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.orgList>>;

export const createFetchOrganizationJobsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getAllOrganizationJobs(buildOrganizationJobsRequest(organizationId, params)),
        signal,
      ),
    );
